/**
 * Party characteristics Emails section
 */
import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const EmailsState = {
  emails: [],
  saveEmailsTriggered: false,
}

export const EmailsActions = {
  fetchEmails: async ({ commit }, req) => {
    return axiosRequest.
      get(`/parties/${req.partyId}/emails`).
      then(({ data }) => {
        commit('setEmails', data.emails)
      }).
      catch(handleError)
  },
  createEmail ({ commit }, req) {
    return axiosRequest.
      post(`/parties/${req.party_id}/emails`, { email: req }).
      then(({ data }) => {
        commit('setEmails', data.emails)
      }).
      catch(handleError)
  },
  saveEmail ({ commit }, req) {
    return axiosRequest.
      patch(`/parties/${req.party_id}/emails/${req.id}`, { email: req }).
      then(({ data }) => {
        commit('setEmails', data.emails)
      }).
      catch(handleError)
  },
}

export const EmailsMutations = {
  setEmails: (state, payload) => { state.emails = payload },
  setEmail: (state, payload) => { if (payload.index !== -1) Vue.set(state.emails, payload.index, payload.data) },
  setEmailsSaveTriggered: (state, payload) => {
    state.saveEmailsTriggered = payload
  },
}

export const EmailsGetters = {
  getEmails: state => state.emails,
  getSaveEmailsTriggered: state => state.saveEmailsTriggered,
}
